import { useSelector } from 'react-redux';

export function useValueSelector<TState = {}, TSelected = unknown>(selector: (state: TState) => TSelected): TSelected {
    return useSelector<TState, TSelected>(selector, (left, right) => JSON.stringify(left) === JSON.stringify(right));
}
